import React, {Fragment} from 'react';
import MOGULHome from "./components/main/home";

const AboutPage = () => {
    return (
        <Fragment>
            <MOGULHome/>
        </Fragment>
    );
};

export default AboutPage;
